<div class="licensed-details-view-container"  fxLayout="column" fxLayoutGap="15px"  *ngIf="licensedObject">
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + licensedObject?.status?.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="licensedObject?.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button
      *ngIf="(userPermissions | async).licensed_agent.admin_root"
      [disabled]="!(userPermissions | async).licensed_agent.admin_root"
      mat-stroked-button (click)="modify()"
    ><mat-icon>create</mat-icon><span> Edytuj</span></button>
    <button
      *ngIf="[AGENT_21_STATUS_REGISTRATION, AGENT_21_STATUS_INVOICE_SENT].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_RESIGNATION)"
    ><span> Rezygnacja</span></button>

    <button
      *ngIf="[AGENT_21_STATUS_REGISTRATION].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_INVOICE_SENT)"
    ><span> Faktura wysłana</span></button>

    <button
      *ngIf="[AGENT_21_STATUS_RESIGNATION].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_REGISTRATION)"
    ><span> Zgłoszenie </span></button>

    <button
      *ngIf="[AGENT_21_STATUS_INVOICE_SENT].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_INVOICE_PAID)"
    ><span> Faktura opłacona </span></button>

    <button
      *ngIf="[AGENT_21_STATUS_INVOICE_PAID].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_SEND_FOR_ACTIVATION)"
    ><span> Wysłana do aktywacji </span></button>

    <button
      *ngIf="[AGENT_21_STATUS_SEND_FOR_ACTIVATION].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_PARTNER_NOTIFICATION)"
    ><span> Powiadomienie Partnera </span></button>

    <button
      *ngIf="[AGENT_21_STATUS_PARTNER_NOTIFICATION].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_ACTIVE)"
    ><span> Aktywna </span></button>

    <button
      *ngIf="[AGENT_21_STATUS_RENEWAL_INVOICE_SENT].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_ACTIVE)"
    ><span> Faktura wznowieniowa opłacona </span></button>

    <button
      *ngIf="[AGENT_21_STATUS_IT_EXPIRES].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.read"
      [disabled]="!(userPermissions | async).licensed_agent.read"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_APPLICATION_FOR_RENEWAL)"
    ><span> Zgłoszenie do odnowienia </span></button>

    <button
      *ngIf="[AGENT_21_STATUS_APPLICATION_FOR_RENEWAL].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.status_editing"
      [disabled]="!(userPermissions | async).licensed_agent.status_editing"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_RENEWAL_INVOICE_SENT)"
    ><span> Faktura wznowieniowa wysłana </span></button>

    <button
      *ngIf="[AGENT_21_STATUS_IT_EXPIRES, AGENT_21_STATUS_RENEWAL_INVOICE_SENT, AGENT_21_STATUS_APPLICATION_FOR_RENEWAL].includes(licensedObject?.status.key)  &&  (userPermissions | async).licensed_agent.read"
      [disabled]="!(userPermissions | async).licensed_agent.read"
      mat-stroked-button (click)="statusTo(AGENT_21_STATUS_CANCELLATION_OF_RENEWAL)"
    ><span>Rezygnacja z odnowienia </span></button>

    <button
      mat-stroked-button
      [style.visibility]="'hidden'"
    ><span>edit</span></button>


  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane licencji</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Data zgłoszenia" [value]="licensedObject?.createdAt  | date:'y-MM-dd'"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Osoba zgłaszająca" [value]="licensedObject?.createdBy?.username"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Adres email osoby zgłaszającej" [value]="licensedObject?.createdBy?.email"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Data wygaśnięcia" [value]="licensedObject?.expirationAt  | date:'y-MM-dd'"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Liczba dni do wygaśnięcia" [value]="(day(licensedObject?.expirationAt))"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>


    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane nabywcy</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Płatnik" [value]="licensedObject?.payer?.name"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Partner" [value]="licensedObject?.partner?.fullName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="OFWCA" [value]="licensedObject?.ofwca?.fullName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Partner" [value]="licensedObject?.partner?.fullName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="ID Partnera" [value]="licensedObject?.partner?.recordId?.toString()"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="ID OFWCA" [value]="licensedObject?.ofwca?.recordId?.toString()"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail *ngIf="licensedObject.partner" header="Regionalny Partner" [value]="licensedObject?.partner?.assetsRegional?.fullName"></app-detail>

              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail *ngIf="licensedObject.ofwca" header="Regionalny Ofwca" [value]="licensedObject?.ofwca?.assetsRegional?.fullName"></app-detail>

              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
            <h5 fxFlex>Adres mailowy</h5>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let row of licensedObject.emails; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <span class="representation-counter" fxFlex="5">{{ i + 1 }}.</span>
                    <app-detail fxFlex="50" header="Adres">{{ row.email }}</app-detail>
                    <app-detail fxFlex="50" header="Nazwa">{{ row.name }}</app-detail>
                  </div>
                </ng-container>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Nr telefonu</h5>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let row of licensedObject.phones; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <span class="representation-counter" fxFlex="5">{{ i + 1 }}.</span>
                    <app-detail fxFlex="50" header="Numer">{{ row.phone }}</app-detail>
                    <app-detail fxFlex="50" header="Nazwa">{{ row.name }}</app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="NIP do licencji" [value]="licensedObject?.licenseNip"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="NIP do faktury" [value]="licensedObject?.invoiceNip"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>

